<!-- src/components/common/ReusableConfirmDialog.vue -->

<template>
  <div>
    <ConfirmDialog :group="group" :style="dialogStyle">
      <template #container="{ message, acceptCallback, rejectCallback }">
        <div class="confirm-dialog-container d-flex flex-column text-center align-items-center p-4 rounded">
          <!-- Icon Section -->
          <div :class="props.defaultIconContainerClass">
            <i :class="iconClass(message)" style="font-size: 3rem"></i>
          </div>

          <!-- Header -->
          <span class="fw-bold fs-2 mb-2 mt-5">{{ message.header }}</span>

          <!-- Message -->
          <p class="mb-0 text-center">{{ message.message }}</p>

          <!-- Action Buttons -->
          <div class="dialog-actions d-flex align-items-center gap-2 mt-5">
            <PvButton :label="acceptLabel" @click="acceptCallback" class="action-btn" rounded />
            <PvButton :label="rejectLabel" outlined @click="rejectCallback" class="action-btn" rounded />
          </div>
        </div>
      </template>
    </ConfirmDialog>    
  </div>

</template>

<script setup>
import ConfirmDialog from 'primevue/confirmdialog';

const props = defineProps({
  group: {
    type: String,
    default: 'headless', // Default group name
  },
  dialogStyle: {
    type: Object,
    default: () => ({ maxWidth: '650px' }), // Default styles
  },
  defaultIconClass: {
    type: String,
    default: 'pi pi-info-circle', // Default PrimeIcons class
  },
  defaultIconContainerClass: {
    type: String,
    default: 'headless-circle bg-primary text-white d-flex-inline justify-content-center align-items-center',
  },
  acceptLabel: {
    type: String,
    default: 'Confirm',
  },
  rejectLabel: {
    type: String,
    default: 'Cancel',
  },
});

const iconClass = (message) => {
  return message?.icon || props.defaultIconClass;
};

</script>

<style scoped>
.confirm-icon {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>